import React from "react";
import MemberInactiveScreen from "./MemberInactiveScreen";
import {getMemberForm, getMemberList, Member, putMember} from "../../../api/member/Member";
import {useHistory} from "react-router-dom";
import {useAsync2} from "../../../hooks/useAsync2";


interface MemberInactiveContainerProps {

}

function MemberInactiveContainer(props: MemberInactiveContainerProps) {

    const history = useHistory()
    const {execute: executePut} = useAsync2(putMember)
    const {data: memberList, execute: executeSearch} = useAsync2(getMemberList, true)
    const {data: form} = useAsync2(getMemberForm, true)

    function handlePut(memberType: Member) {
        executePut(memberType).then(
            () => {
                alert("수정되었습니다.")
                history.go(0)
            }
        )
    }

    function getOnlyInactiveMemberArr(memberArr: Member[] | undefined): Member[] {
        if (!memberArr) return []

        return memberArr.filter(member => member.state == 2)
    }

    return (
        <MemberInactiveScreen
            memberArr={getOnlyInactiveMemberArr(memberList)}
            handleGet={executeSearch}
            handlePut={handlePut}
            form={form}
        />
    )
}

export default MemberInactiveContainer